var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhEyeFill3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:eye-fill",
    clipPath: "url(#clip0_14_9640)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 12.625,
    cy: 12.5,
    r: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2764 12.1836C24.2422 12.1064 23.415 10.2715 21.5762 8.43262C19.126 5.98242 16.0312 4.6875 12.625 4.6875C9.21874 4.6875 6.12401 5.98242 3.67382 8.43262C1.83495 10.2715 1.0039 12.1094 0.973623 12.1836C0.929203 12.2835 0.90625 12.3916 0.90625 12.501C0.90625 12.6103 0.929203 12.7184 0.973623 12.8184C1.0078 12.8955 1.83495 14.7295 3.67382 16.5684C6.12401 19.0176 9.21874 20.3125 12.625 20.3125C16.0312 20.3125 19.126 19.0176 21.5762 16.5684C23.415 14.7295 24.2422 12.8955 24.2764 12.8184C24.3208 12.7184 24.3437 12.6103 24.3437 12.501C24.3437 12.3916 24.3208 12.2835 24.2764 12.1836ZM12.625 16.4062C11.8524 16.4062 11.0972 16.1772 10.4548 15.7479C9.81242 15.3187 9.31174 14.7086 9.01609 13.9949C8.72043 13.2811 8.64307 12.4957 8.7938 11.7379C8.94452 10.9802 9.31656 10.2842 9.86285 9.73786C10.4092 9.19157 11.1052 8.81953 11.8629 8.66881C12.6207 8.51808 13.4061 8.59544 14.1198 8.8911C14.8336 9.18675 15.4437 9.68742 15.8729 10.3298C16.3021 10.9722 16.5312 11.7274 16.5312 12.5C16.5312 13.536 16.1197 14.5296 15.3871 15.2621C14.6546 15.9947 13.661 16.4062 12.625 16.4062Z",
    fill: "#eb2426"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_9640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhEyeFill3);
export default __webpack_public_path__ + "static/media/ph_eye-fill-3.7b03e18b2ac810fd972608932e88529a.svg";
export { ForwardRef as ReactComponent };